interface GreenDotProps {
  size?: "sm" | "md";
  withRing?: boolean;
  pulse?: boolean;
}

export function GreenDot({ size = "sm", withRing = false, pulse = false }: GreenDotProps) {
  const sizeClass = size === "md" ? "h-2.5 w-2.5" : "h-2 w-2";

  return (
    <span
      aria-hidden="true"
      className={[
        "inline-flex rounded-full bg-green",
        sizeClass,
        pulse ? "animate-pulse" : "",
        withRing ? "ring-2 ring-light" : "",
      ].join(" ")}
    />
  );
}
